// removed by extract-text-webpack-plugin
module.exports = {"font":"_3-BtO-9I8EOGiLrLeR0h8t","heading":"ZSbjFWi6HLaS4NcbeOAq","size14":"mIcH8C23DKnR2HpczZF8E","size15":"_2X5c88VqgmyA7Ml5Kc8ELo"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/atoms/Font/style.css
// module id = 262
// module chunks = 37